import $ from 'jquery';
import AccountService from '../_shared/account-service';

export default class UmbracoFormsPrePopulation {
    constructor(containerSelector = '.umbraco-forms-form') {
        this.userDictionary = {};
        this.$container = document.querySelector(containerSelector);
        this.init();
    }

    async init() {
        this.initialized = true;

        if (!this.$container) {
            this.initialized = false;
            return;
        }

        this.userInfo = await AccountService.getUserInfoApi();
        if (!this.userInfo) { return; }

        await this.addAlias();
        await this.fixDOBFormat();

        this.match();
    }

    addAlias() {
        return new Promise((resolve) => {
            this.userInfo.surname = this.userInfo.lastName;
            this.userInfo.postcode = this.userInfo.zip;
            delete this.userInfo.id;
            delete this.userInfo.stripeId;
            resolve(true);
        });
    }

    fixDOBFormat() {
        return new Promise((resolve) => {
            const year = this.userInfo.birthYear;
            const month = String(this.userInfo.birthMonth).padStart(2, '0');
            const day = String(this.userInfo.birthDay).padStart(2, '0');
            this.userInfo.dateOfBirth = `${year}-${month}-${day}`;
            resolve(true);
        });
    }

    match() {
        const fields = this.$container.querySelectorAll('.umbraco-forms-field');
        const userInfoKeys = Object.keys(this.userInfo);

        const urlSearchParams = new URLSearchParams(window.location.search.toLowerCase());
        const params = Object.fromEntries(urlSearchParams.entries());

        fields.forEach((field) => {
            const label = field.querySelector('label');
            if (label) {
                const value = label.innerText.toLowerCase().replaceAll(' ', '').replaceAll('*', '');
                userInfoKeys.forEach((key) => {
                    if (value === key.toLowerCase()) {
                        // eslint-disable-next-line no-param-reassign
                        const input = field.querySelector('input');

                        if (input && input.type === 'text') {
                            const aliasAttribute = input.getAttribute('alias');

                            if (aliasAttribute === undefined || aliasAttribute === null) {
                                input.value = this.userInfo[key];
                            } else {
                                const queryStringParam = params[aliasAttribute.toLowerCase()];

                                if (queryStringParam === undefined) {
                                    input.value = this.userInfo[key];
                                }
                            }

                            // date picker fallback
                            if ($(input).data('datepicker')) {
                                $(input).data('datepicker').selectDate(new Date($(input).val()));
                            }
                        }
                    }
                });
            }
        });
    }
}
